import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrIcon } from "./CrIcon";

interface HbListItemTextElementProps {
  type: "TEXT";
  text: string;
}

interface HbListItemChipElementProps {
  type: "CHIP";
  text: string | null;
  color?: "PRIMARY" | "WARNING" | "DANGER" | "SUCCESS" | "FADE-OUT" | "BLACK";
}

type HbListItemElementProps = HbListItemTextElementProps | HbListItemChipElementProps;

export interface HbListItemProps {
  elements: Array<HbListItemElementProps>;
  accessory?: "DISCLOSURE";
  onClick?: (() => void) | false;
  fontSize?: "SMALL" | "MEDIUM" | "LARGE";
}

function HbListItemChipColumn(props: HbListItemChipElementProps & { fontSize?: "SMALL" | "MEDIUM" | "LARGE" }) {
  return (
    <>
      {!!props.text && (
        <span
          className={classNames("hb-list-item-column--chip", `--color-${String(props.color || "default").toLowerCase()}`, {
            "font--small": props.fontSize === "SMALL",
            "font--medium": props.fontSize === "MEDIUM",
            "font--large": props.fontSize === "LARGE",
          })}
        >
          {props.text}
        </span>
      )}
    </>
  );
}

function HbListItemColumn(props: HbListItemElementProps & { fontSize?: "SMALL" | "MEDIUM" | "LARGE" }) {
  return (
    <div
      className={classNames("hb-list-item-colum", `--type-${String(props.type).toLowerCase()}`, {
        "font--small": props.fontSize === "SMALL",
        "font--medium": props.fontSize === "MEDIUM",
        "font--large": props.fontSize === "LARGE",
      })}
    >
      {props.type === "TEXT" && <>{props.text}</>}
      {props.type === "CHIP" && <HbListItemChipColumn {...props} />}
    </div>
  );
}

export function HbListItem(props: HbListItemProps) {
  const { elements, accessory, onClick, fontSize } = props;

  return (
    <div
      className={classNames("hb-list-item", onClick === false && "--disabled")}
      onClick={() => (typeof onClick === "function" ? onClick() : undefined)}
    >
      <div className="hb-list-item-columns">
        <div className="hb-list-item-columns-wrap">
          {elements.map((element, i) => (
            <HbListItemColumn key={i} {...element} fontSize={fontSize} />
          ))}
        </div>
        {accessory === "DISCLOSURE" && (
          <div className="hb-list-item-colum --accessory --disclosure">
            <CrIcon icon="ChevronRightSmall" />
          </div>
        )}
      </div>
    </div>
  );
}
